import React, { useEffect, useState } from 'react';
import UserService from './services/userService';
import AuthService from './services/authService';
import BookmarkService from './services/bookmarkService'

const AppContext = React.createContext();
export const AppProvider = ({ children }) => {
  const [logo, setLogo] = useState(null);
  const [isLogedIn, setIsLogedIn] = useState(false);
  const [subtitleModified, setSubtitleModified] = useState("");
  const [titleModified, setTitleModified] = useState("");

  const [bookmarks, setBookmarks] = useState([])

  const getLogo = async () => {
    const id = AuthService.getUserGroupId()
    const res = await UserService.getUserGroupById(id)
    let groupLogo = res.data?.Data.Logo
    if (groupLogo) {
      console.log(groupLogo);
      localStorage.setItem("Group_logo", "data:image;base64," + groupLogo);
    }
  };
  const getBookmarks = async () => {
    const userId = AuthService.getUserId();
    try {
      const res = await BookmarkService.GetBookmarkedPages({ userId });
      const bookmarks = res.data?.data?.Data;
      setBookmarks(bookmarks);
    } catch (error) {

      console.error("Error fetching bookmarks:", error);
    }
  };
  useEffect(() => {
    if (isLogedIn && !logo && !AuthService.isSuperAdmin())  {
      getLogo()
    }
    getBookmarks()
  }, [isLogedIn])

  return (
    <AppContext.Provider
      value={{
        logo,
        isLogedIn,
        setIsLogedIn,
        bookmarks,
        getBookmarks,
        subtitleModified,
        setSubtitleModified,
        titleModified,
        setTitleModified
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export default AppContext;
